import React from "react";
import { PolyIcon } from "elements";
import { useTranslation } from "utilities/i18n";

interface LoadingIndicatorProps {
  title?: string; // optional - title to override the default title....
  className?: string;
}

/**
 * Render a spinning "loader" icon plus the phrase "loading..."
 *
 * @example <LoadingIndicator title="Please Wait..." />
 *
 * @param {LoadingIndicatorProps} props
 *
 */
const LoadingIndicator: React.FC<LoadingIndicatorProps> = props => {
  const { t } = useTranslation();
  const classes = ["loading-indicator", props.className || ""].join(" ");

  const title = props.title || t("LOADING");
  return (
    <div className={classes} data-testid="loading-indicator">
      <PolyIcon icon="refresh" className="spin" /> {title}
    </div>
  );
};

export default LoadingIndicator;
